"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AccessibilitySmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,6 C7.8954305,6 7,5.1045695 7,4 C7,2.8954305 7.8954305,2 9,2 C10.1045695,2 11,2.8954305 11,4 C11,5.1045695 10.1045695,6 9,6 Z M9,5 C9.55228475,5 10,4.55228475 10,4 C10,3.44771525 9.55228475,3 9,3 C8.44771525,3 8,3.44771525 8,4 C8,4.55228475 8.44771525,5 9,5 Z M6,8.86037961 L3.68377223,8.08830369 C3.27543009,7.95218964 3,7.5700508 3,7.13962039 L3,6.93018981 C3,6.41646016 3.41646016,6 3.93018981,6 L14.0698102,6 C14.5835398,6 15,6.41646016 15,6.93018981 L15,7.13962039 C15,7.5700508 14.7245699,7.95218964 14.3162278,8.08830369 L12,8.86037961 L12,15.0548059 C12,15.5768222 11.5768222,16 11.0548059,16 L10.8903882,16 C10.4315206,16 10.0315375,15.6877026 9.9202457,15.2425356 L9.1096118,12 L8.8903882,12 L8.0797543,15.2425356 C7.96846255,15.6877026 7.56847944,16 7.1096118,16 L6.9451941,16 C6.42317781,16 6,15.5768222 6,15.0548059 L6,8.86037961 Z M4,7 L4,7.13962039 L7,8.13962039 L7,15 L7.1096118,15 L7.9202457,11.7574644 C8.03153745,11.3122974 8.43152056,11 8.8903882,11 L9.1096118,11 C9.56847944,11 9.96846255,11.3122974 10.0797543,11.7574644 L10.8903882,15 L11,15 L11,8.13962039 L14,7.13962039 L14,7 L4,7 Z" })));
};
AccessibilitySmall.displayName = 'AccessibilitySmall';
exports.default = AccessibilitySmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AccessibilitySmall.js.map